import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './main.css' // Import Tailwind directives first
import './index.css' // Then custom styles
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
